const data = [
  { pic: './public/images/about-inner.jpg', items: [
    'Unique blend of services under one roof.',
    'Mid size-able to react promptly to situations.',
    'We work closely and collboratively with our clients.',
    'We are a team of experts that have a good knowledge of business.',
    'We provide early identification and resolution of clients accounting solutions.',
  ]},

];
export default data;



// WEBPACK FOOTER //
// ./src/AboutPage/data.js